import React from 'react'
import { down } from 'styled-breakpoints'
import styled from 'styled-components'
import { MOBILE } from '../../lib/constant'

export default function Footer() {
	return (
		<FooterBlock>
			<CompanyInfo>
				슈어모빌리티(주) 소재지 : 경기 성남시 수정구 금토동 324-1, E동 2층(금토동, 인피니티 타워) (우편번호: 461380)
				<em> 대표 : </em> 김호태{' '}
				<em> 사업자등록번호 : </em> 374-86-01317
				<em> TEL : </em> (031)606-2075
			</CompanyInfo>
			<Copyright>
				Copyright © 2023 슈어모빌리티(주) All Rights Reserved.
			</Copyright>
			<Privacy>
				<li>
					<a
						href="https://www.tagoga.net/policy/service.pdf"
						target="_blank"
						rel="noreferrer"
					>
						서비스 이용약관
					</a>
				</li>
				<li>
					<a
						href="https://www.tagoga.net/policy/location.pdf"
						target="_blank"
						rel="noreferrer"
					>
						위치정보사업 이용약관
					</a>
				</li>
				<li>
					<a
						href="https://www.tagoga.net/policy/rent.pdf"
						target="_blank"
						rel="noreferrer"
					>
						임대 이용약관
					</a>
				</li>
				<li>
					<a
						href="https://www.tagoga.net/policy/privacy.pdf"
						target="_blank"
						rel="noreferrer"
					>
						플랫폼 개인정보 처리방침
					</a>
				</li>
				<li>
					<a
						href="https://www.tagoga.net/policy/location_service.pdf"
						target="_blank"
						rel="noreferrer"
					>
						플랫폼 위치기반서비스 이용약관
					</a>
				</li>
			</Privacy>
		</FooterBlock>
	)
}

const FooterBlock = styled.footer`
	min-height: 72px;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	font-size: 14px;
	line-height: 20px;
	margin-bottom: 7px;
	padding: 16px;
	color: #acacac;
	text-align: center;
	margin-top: auto;
`

const CompanyInfo = styled.p`
	& > em {
		font-weight: 700;
	}
`

const Copyright = styled.p``

const Privacy = styled.ul`
	margin-top: 16px;
	display: flex;
	flex-wrap: wrap;

	> li {
		> a {
			font-size: 14px;
			line-height: 20px;
			color: #eb4c60;
		}
		&:not(:last-child) {
			margin-right: 16px;
		}
	}

	${down(MOBILE)} {
		margin-top: 32px;
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 8px;
		align-items: flex-start;
		text-align: start;
	}
`
